// extracted by mini-css-extract-plugin
module.exports = {"loginTitle":"_1gcxy","root":"_1hm78","centered":"_3aW73","formField":"_1CvLj","NextButton":"_2pCqi","SaveChange":"_1gNNa","buttonWrap":"_2sWh7","alreadyLogin":"ScmRd"};